(() => {
  function init(root) {
    if (root.dataset.cacReady) return;
    const tabs = Array.from(root.querySelectorAll('[data-cac-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cac-panel]'));
    if (!tabs.length || !panels.length) return;
    root.dataset.cacReady = 'true';
    root.classList.add('cac--enhanced');
    const nav = root.querySelector('[data-cac-nav]');
    const tablist = document.createElement('div');
    tablist.className = 'cac-nav-tabs';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', nav.getAttribute('aria-label') || 'Account');
    nav.insertBefore(tablist, nav.firstChild);
    tabs.forEach(tab => tablist.appendChild(tab));
    function select(key, focus, updateHash = true) {
      const tab = tabs.find(item => item.dataset.cacTab === key);
      const panel = panels.find(item => item.dataset.cacPanel === key);
      if (!tab || !panel) return;
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(item => { item.hidden = item !== panel; });
      if (focus) tab.focus();
      if (updateHash) {
        try { history.replaceState(null, '', '#' + panel.id); } catch (_) {}
      }
      root.dispatchEvent(new CustomEvent('cac:panel-change', {detail: {key}}));
    }
    tabs.forEach((tab, index) => {
      const panel = panels.find(item => item.dataset.cacPanel === tab.dataset.cacTab);
      if (!panel) return;
      tab.id ||= 'cac-tab-' + panel.id;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', event => { event.preventDefault(); select(tab.dataset.cacTab, false); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); select(tabs[next].dataset.cacTab, true);
      });
    });
    root.querySelectorAll('[data-cac-go]').forEach(link => link.addEventListener('click', event => {
      const key = link.dataset.cacGo;
      if (!panels.some(panel => panel.dataset.cacPanel === key)) return;
      event.preventDefault(); select(key, false);
    }));
    function fromHash() {
      if (!root.isConnected) return;
      const matching = panels.find(item => '#' + item.id === location.hash);
      select(matching ? matching.dataset.cacPanel : 'overview', false, false);
    }
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  document.querySelectorAll('[data-account-center]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-account-center]').forEach(init));
})();
